module.exports = {
    "breadcrumbs": `Putanje navigacije`
};


//# sourceMappingURL=sr-SP.main.js.map
